import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import '../css/surprise2106.css';
import Bg from '../images/Event/surprise2106/bg.png';

class EventSurprise2106 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollTop: 0
    };
  }

  componentDidMount() {
    window.pageVisit("surprise", "2106");
    window.addEventListener("scroll", this.onScroll);
  }

  onScroll = (e) => {
    const scrollTop = ("scroll", e.srcElement.scrollingElement.scrollTop);
    this.setState({scrollTop: scrollTop});
  }

  render() {
    return (
      <Fragment>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont surprise2106" style={{background: '#344a58'}}>
              <div id="contents" style={{background: '#344a58'}}>
                <img src={Bg} style={{width: '100%'}} />
                <Link to="/event/consulting_june" className="BtnConsulting"></Link>
              </div>
              <Link to="/event/branch/100" className={`banner ${this.state.scrollTop > 500 ? "show" : ""}`} onClick={() => window.pageComplete("surprise", "2106")}></Link>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default EventSurprise2106;
